<div class="filter__wrapper" *ngIf="!loading">
    <div class="filter__top">
        <div class="filter__top-iconback">
            <img
                src="./assets/icons/navigation/back.svg"
                alt="arrow_back"
                (click)="toggleDropdown()"
            />
        </div>
        <div class="filter-top__title">Фильтр</div>
    </div>
    <div class="filter__list">
        <div
            class="filter__list-item"
            *ngFor="let stBTN of filterList"
            (click)="onLabelClick(stBTN.keyId)"
            [class.selected]="stBTN.keyId === staticFilterSelected"
        >
            <label for="consultation_{{ stBTN.keyId }}" class="checkbox__label">
                {{ stBTN.text }}
            </label>
        </div>
    </div>
    <div class="filter__buttons">
        <button class="buttons filter__buttons-reset" (click)="clearFilter()">
            Сбросить
        </button>
        <button class="buttons filter__buttons-apply" (click)="searchClick()">
            Применить
        </button>
    </div>
</div>
<div class="loader" *ngIf="loading">
    <loader type="page"> </loader>
</div>
